import { AfterViewInit, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accounthome',
  templateUrl: './accounthome.component.html',
  styleUrls: ['./accounthome.component.scss']
})
export class AccounthomeComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }
}
